import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import OsteopataContext from "../../context/osteopata";
import UserContext from "../../context/user";

const useOsteopathCreateMutation = () => {
  const { callApi, userProfile } = useContext(UserContext);
  const { setCurrentRequest } = useContext(OsteopataContext);
  const queryClient = useQueryClient();

  return useMutation(
    ({ osteopathId, formData, selectedDate }) =>
      callApi(`/osteopath/request/${osteopathId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          welfareEmail: formData.email,
          welfarePhone: formData.phone,
          bookingDate: selectedDate.toISOString(),
          osteopathId,
        }),
      }),
    {
      onSuccess: () => {
        setCurrentRequest();
        queryClient.invalidateQueries(["requests", JSON.stringify(userProfile)]);
      },
    }
  );
};

export default useOsteopathCreateMutation;
